export default __webpack_public_path__ + "static/media/ab1.2be8f23a.png";